<template>
    <span  v-if="canEdit" class="img-edit">
        <div class="badge-button rounded" @click.prevent="change()">
            <div class="icon">
                <span class="material-icons">photo_camera</span>
            </div>
        </div>
        <span @click.prevent="change()" :class="{loading:saving}"
              class="rounded avatar-image" v-bind:style="{ backgroundImage:'url('+avatarImage+')', width:width+'px', height:width+'px' }">
            <div class="loader"></div>
        </span>
        <span class="hide"><input @change="loadPreview" type="file" name="avatar" /></span>
    </span>
    <img v-else-if="!canEdit" class="rounded" v-bind:src="avatarImage" :width="width">
</template>

<script>
module.exports = {
    created: function () {
        if(this.editable != undefined) {
            this.canEdit = true;
        }
        if(this.image != undefined) {
            this.avatarImage = this.image;
        }
        if(this.autosave != undefined) {
            this.autoSave = true;
        }
    },
    data:function() {
        return {
            canEdit:false,
            avatarImage:'',
            autoSave:false,
            saving:false
        }
    },
    props: {
        image:{type:String,default:''},
        width:{type:String},
        editable:{type:String},
        autosave:{type:String},
        action:{type:String,default:'/settings/avatar'}
    },
    methods: {
        change:function() {
            if(this.canEdit) {
                $(this.$el).find('input').click();
            }
        },
        loadPreview:function(e) {
            var file = e.target.files[0];
            var el = this;
            if (file != undefined) {
                var imagefile = file.type;
                var accepted = [
                    'image/jpeg',
                    'image/jpg',
                    'image/png'
                ]
                if (accepted.includes(imagefile)) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = function () {
                        if(el.autoSave) {
                            if(!el.saving) {
                                var formData = new FormData();
                                formData.append('avatar', file);
                                formData.append('_method','PATCH');
                                $(el.$el).find('.loader').show();
                                $.ajax({
                                    type: "POST",
                                    url:el.action,
                                    cache: false,
                                    contentType: false,
                                    processData: false,
                                    data: formData,
                                    success: function (result) {
                                        $(el.$el).find('.loader').hide();
                                        if(result.data != undefined && result.data.profile_image != undefined) {
                                            el.avatarImage = result.data.profile_image;
                                            el.$root.avatar = result.data.profile_image;
                                        } else if(result.data != undefined && result.data.image != undefined) {
                                            el.avatarImage = result.data.image;
                                        } else if(result.msg != undefined) {
                                            alert(result.msg);
                                        } else {
                                            alert('An error occured. Please try again.');
                                        }
                                    },
                                    error :function() {
                                        alert("An error occured. Please try again.");
                                        $(el.$el).find('.loader').hide();
                                    }
                                })
                            }
                        } else {
                            el.avatarImage = reader.result;
                            el.$root.avatar = reader.result;
                        }
                    }
                }
            }
        }
    }
}
</script>
